import React, { useEffect, useRef, useState } from "react";
import Header from "../../Global/Header/Header";
import Footer from "../../Global/Footer/Footer";
import classes from './Blogs.module.css'
import ScrollToTopOnNavigate from "../../ScrollToTop";
import { useNavigate } from "react-router-dom";
import { get, createUrl } from "../../network/AxiosInterceptor";


const Blogs = () => {

    ScrollToTopOnNavigate();

    const blogContainerRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [blogs, setBlogs] = useState([]);

    const navigate = useNavigate();

    const handleScroll = (e) => {
        console.log(e);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        try {
            get(createUrl('/api/blogs')).then((response) => {
                setBlogs(response.data)
            }).catch(e => {
                console.log(e, ' error ')
            })
        } catch (e) {
            console.log(e, ' error')
        }

    }, [])

    useEffect(() => {
        let scrollInterval;
        var scrollSetter = -1;
        var blogSetter = blogContainerRef.current.scrollLeft;

        const stopScroll = () => {
            clearInterval(scrollInterval);
        };

        const startScroll = () => {
            scrollInterval = setInterval(() => {
                if (blogContainerRef.current.scrollLeft == 0) scrollSetter = -1;
                if (blogContainerRef.current && scrollSetter < blogContainerRef.current.scrollLeft) {
                    scrollSetter = blogContainerRef.current.scrollLeft;
                    blogContainerRef.current.scrollLeft += 1; // Adjust the scroll speed here
                    blogSetter = blogContainerRef.current.scrollLeft;

                } else {
                    scrollSetter = blogContainerRef.current.scrollLeft;
                    blogContainerRef.current.scrollLeft -= 1000;
                    blogSetter = blogContainerRef.current.scrollLeft;
                }
            }, 10); // Adjust the interval (milliseconds) as needed
        };

        startScroll(); // Start scrolling automatically when component mounts

        // Add event listeners for mouseenter and mouseleave to stop and start scrolling
        if (blogContainerRef.current) {
            blogContainerRef.current.addEventListener('mouseenter', stopScroll);
            blogContainerRef.current.addEventListener('mouseleave', startScroll);
        }

        return () => {
            clearInterval(scrollInterval);
            if (blogContainerRef.current) {
                blogContainerRef.current.removeEventListener('mouseenter', stopScroll);
                blogContainerRef.current.removeEventListener('mouseleave', startScroll);
            }
        };
    }, []);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - blogContainerRef.current.offsetLeft);
        setScrollLeft(blogContainerRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDragging(false);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - blogContainerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll-fast
        blogContainerRef.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <>
            {blogs.length > 0 && <div className="min-h-[100vh] w-screen ">
                <img className="w-full absolute z-[-1]" src="https://static.wixstatic.com/media/da937f_3ce6d8bd31da4b2b8fd7a77693fe5ac6~mv2.webp" alt="" />
                <Header />
                <div className="min-h-[80vh] w-screen flex flex-col justify-center items-center p-0 pb-[4vw]">
                    <div className={`${classes['blog-card-container']} w-[80vw] lg:w-[87vw] min-h-[70vh] lg:min-h-[30vw] mt-[2vw] flex flex-col lg:flex-row lg:flex-wrap gap-y-[4vh] lg:gap-y-[3vw]`}>
                        {
                            blogs.length > 0 && blogs.map((blog) => {
                                return (
                                    <div className={`${classes['blog-card']} w-full lg:w-[27vw] h-[55vh] lg:h-[37vw] border-[1px] border-blue-300 rounded-[10px] overflow-hidden cursor-pointer`}>
                                        <div className="w-full h-[25vh] lg:h-[18vw]" onClick={() => {
                                            navigate(`/blog/${blog.blogIdAlias}`)
                                        }}>
                                            <img className="w-full h-full" src={blog.imageUrl} alt="Loading ..." />
                                        </div>
                                        <div className="w-full h-[30vh] p-[1.5vh] lg:h-[19vw] lg:p-[1vw]">
                                            <div className="w-full h-full">
                                                <div className="w-full h-[5vh] lg:h-[2.5vw] flex flex-row items-center" onClick={() => {
                                                    navigate(`/blog/${blog.blogIdAlias}`)
                                                }}>
                                                    <div className="flex flex-row items-center">
                                                        <div className="w-[5vh] lg:w-[2.5vw] h-[5vh] lg:h-[2.5vw] rounded-full overflow-hidden">
                                                            <img className="w-full h-full object-cover" src={blog.authorPic || blog.authorId.profilePic} alt="" />
                                                        </div>
                                                        <div className="flex flex-col h-[5vh] lg:h-[2.5vw] ml-[10px] text-[3vw] justify-center lg:text-[0.8vw]">
                                                            <p>{blog.authorId.fullName}</p>
                                                            <div className="flex flex-row items-center">
                                                                <p>{Date(blog.createdAt).substring(4, 15)}&nbsp;&nbsp;&nbsp;</p><div className="w-[1vw] h-[1vw] lg:w-[0.2vw] lg:h-[0.2vw] bg-black rounded-full"></div><p>&nbsp;&nbsp;&nbsp;{blog.readingTime}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <svg className="ml-[auto] cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 24" width="24" height="24" fill="#000000">
                                                        <circle cx="12" cy="5" r="2" />
                                                        <circle cx="12" cy="12" r="2" />
                                                        <circle cx="12" cy="19" r="2" />
                                                    </svg>
                                                </div>

                                                {/* Heading and Sub Heading  */}
                                                <div className="w-full h-[18vh] lg:h-[11.5vw] flex flex-col mt-[1vh] lg:mt-[1vw] border-b-[2px] border-blue-500" onClick={() => {
                                                    navigate(`/blog/${blog.blogIdAlias}`)
                                                }}>
                                                    <p className="text-[2vh] lg:text-[1.7vw] w-full max-h-[4.7vh] lg:max-h-[3.8vw] leading-[2.3vh] lg:leading-[1.8vw] overflow-hidden">{blog.heading}</p>
                                                    <p className="text-[1.3vh] mt-[0.5vh] text-justify lg:text-[1vw] w-full max-h-[11vh] lg:max-h-[5.8vw] lg:mt-[0.3vw] overflow-hidden leading-[1.8vh] lg:leading-[1.4vw]">{blog.subHeading}</p>
                                                </div>
                                                <div className="w-full h-[3vh] pt-[0.5vh] lg:pt-0 lg:h-[2vw] flex flex-row items-center">
                                                    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M20.81 11.27C19.77 9.38 16.79 5 11.5 5c-5.29 0-8.27 4.38-9.31 6.27-.12.22-.19.47-.19.73s.06.51.19.73C3.23 14.62 6.21 19 11.5 19c5.29 0 8.28-4.38 9.31-6.27.12-.22.19-.47.19-.73s-.06-.51-.19-.73Zm-.88.98C18.98 13.98 16.26 18 11.5 18s-7.48-4.02-8.44-5.75a.542.542 0 0 1 0-.5C4.01 10.02 6.73 6 11.49 6s7.48 4.02 8.44 5.75a.542.542 0 0 1 0 .5Zm-6.25-2.99c-.63-.5-1.42-.77-2.23-.76-.81.01-1.59.3-2.21.83-.62.52-1.04 1.24-1.18 2.04a3.503 3.503 0 0 0 2.15 3.89c.75.3 1.59.33 2.36.08a3.51 3.51 0 0 0 1.87-1.43c.44-.68.63-1.49.54-2.3a3.471 3.471 0 0 0-1.29-2.34l-.01-.01Zm-.23 4.3c-.36.45-.87.77-1.43.89-.57.12-1.16.04-1.67-.22-.51-.27-.92-.7-1.15-1.23-.23-.53-.27-1.13-.11-1.68a2.484 2.484 0 0 1 2.61-1.8c.58.05 1.12.3 1.53.7.42.4.68.94.74 1.51.04.33.01.66-.08.97-.09.32-.24.61-.45.87l.01-.01Z"></path></svg>
                                                    <p className="text-[1.5vh] lg:text-[1vw]">{blog.blogViews || 10}</p>
                                                    <svg className="ml-[auto]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round">
                                                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <Footer />
            </div>}


            {/* -------------------------------------------------------------------------------------------- */}
            {/* -------------------------------------------------------------------------------------------- */}
            {/* -------------------------------------------------------------------------------------------- */}
            {/* -------------------------------------------------------------------------------------------- */}
            {/* -------------------------------------------------------------------------------------------- */}
            {/* -------------------------------------------------------------------------------------------- */}

            {/*  Old blog Page */}

            <div className={`${classes["blog-page"]} relative hidden`}>
                <div className="absolute top-0 left-0 right-0">
                    <Header />
                </div>
                <div className="absolute w-full h-[100vh]"
                // style={{background: "linear-gradient(to bottom, rgba(255,255,255, 0) 80%, rgba(255,255,255, 1) 100%)"}}
                >

                    <img className="absolute mt-[20vh] ml-[60%] w-[30vw] transform rotate-[-5deg]" src="/images/airplane.png" />

                    <img className="w-full h-[100vh] relative z-[-1]" src="https://images.unsplash.com/photo-1428908728789-d2de25dbd4e2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" />

                </div>

                <div className="absolute min-w-[38vw] h-[30vh] mt-[28vh] ml-[8vw] rounded-[20px] text-blue-700 flex flex-col justify-center" style={{ backgroundColor: "rgb(255,255,255,0.4)" }}>
                    <div className="ml-[2vw] mr-[4vw]">
                        <p className="text-[3vw]">HI ! </p>
                        <p className="text-[3vw]"> Welcome to Exploro</p>
                    </div>
                </div>
                <div className="w-full h-[100vh]">{/* Spacing container used to shift blogs down the image */}</div>
                <div className={`${classes["blog-info"]} pt-[3vw]`}>
                    <div className="w-full">
                        <p className="w-full text-center text-[3vw]">Welcome to Exploro</p>
                        <p className="w-full text-center text-[1.2vw]">Where curiosity meets discovery. Let's start exploring together!</p>
                    </div>

                    <div className="mt-[2vh] h-[90vh] flex flex-col justify-center items-center">
                        <div className={classes["blog-container-border"]}>
                            <div className={`${classes['blog-container']} max-w-[92vw] flex flex-row justify-between space-x-[2vw] items-center rounded-[15px]`} ref={blogContainerRef}
                                onMouseDown={handleMouseDown}
                                onMouseLeave={handleMouseLeave}
                                onMouseUp={handleMouseUp}
                                onMouseMove={handleMouseMove}
                            >
                                {
                                    blogs.map(a => {
                                        return (
                                            <div className={`${classes['blog-single']} flex flex-col h-[60vh] min-w-[21vw] rounded-[13px] overflow-hidden`}
                                                onClick={() => { window.location.href = 'https://blog.exploro.club/about' }}
                                            >
                                                <img className="h-[30vh] w-full" src="https://static.wixstatic.com/media/da937f_d17f8f76d0b44ac5af7fc24561fcc425~mv2.jpg" />
                                                {/* <div className="relative z-[1] h-[30vh] w-full mt-[-30vh]"></div> */}
                                                <div className="h-[30vh] w-full p-[20px] flex flex-col items-center">
                                                    <p className="w-full max-h-[8vh] overflow-hidden text-lg bold">A Serene Getaway: My Enchanting Trip to Darjeeling</p>
                                                    <p className={`${classes["blog-sub-heading"]} w-full max-h-[15vh] mt-[0.5vw] overflow-hidden overflow-y-scroll text-sm`}>Exploring the Majestic Hills, Lush Tea Gardens, and Vibrant Culture.Exploring the Majestic Hills, Lush Tea Gardens, and Vibrant CultureExploring the Majestic Hills, Lush Tea Gardens, and Vibrant CultureExploring the Majestic Hills, Lush Tea Gardens, and Vibrant Culture</p>
                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                        </div>
                    </div>
                    <iframe className="w-full h-100vh" src="" />
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Blogs;